import { useLocation } from 'react-router-dom';

import { OVERLAY_PAGE_SEGMENTS } from '@frontend/constants';

/**
 * Whether the current route is one where the Opal chat overlay may open. Mirrors
 * the overlay's own gate: a segment-membership test against OVERLAY_PAGE_SEGMENTS.
 */
export function useIsOnOverlayPage(): boolean {
  const { pathname } = useLocation();
  const segments = pathname.split('/');
  return OVERLAY_PAGE_SEGMENTS.some(segment => segments.includes(segment));
}
